module.exports = __webpack_public_path__ + "img/new-zealand.a1c43634.png";